module.exports = __webpack_public_path__ + "media/Dotkit-ClearAll.86242865.mp4";